<template>
  <div>
    <div style="margin: 4rem 3rem">
      <h4>Inside sales contact details</h4>
      <div class="well">
        <div class="form-group">
          <label for="sales-contact-name">Contact name</label>
          <input
            id="sales-contact-name"
            v-model="salesContactName"
            class="form-control"
            type="text"
          />
        </div>
        <div class="form-group">
          <label for="sales-contact-email">Contact email</label>
          <input
            id="sales-contact-email"
            v-model="salesContactEmail"
            class="form-control"
            type="email"
          />
        </div>
        <div class="form-group">
          <label for="sales-contact-phone">Contact phone number</label>
          <input
            id="sales-contact-phone"
            v-model="salesContactPhone"
            v-mask="phoneMask"
            class="form-control"
            type="text"
          />
        </div>
      </div>
    </div>
    <div style="display: flex; flex-flow: row; justify-content: space-between">
      <button class="btn btn-secondary" @click="handlePrev">Back</button>
      <button
        class="btn btn-primary"
        :disabled="
          salesContactName === null ||
          salesContactEmail === null ||
          salesContactPhone == null
        "
        @click="handleNext"
      >
        Next
      </button>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import phoneNumber from "../../../../inputMasks/phoneNumber";

export default {
  data() {
    return {
      phoneMask: phoneNumber(),
    };
  },
  computed: {
    ...mapState(["manufacturer"]),
    salesContactName: {
      set(value) {
        return this.$store.commit("manufacturer/SET_SALES_CONTACT_NAME", value);
      },
      get() {
        return this.manufacturer.salesContactName;
      },
    },
    salesContactEmail: {
      set(value) {
        return this.$store.commit(
          "manufacturer/SET_SALES_CONTACT_EMAIL",
          value
        );
      },
      get() {
        return this.manufacturer.salesContactEmail;
      },
    },
    salesContactPhone: {
      set(value) {
        return this.$store.commit(
          "manufacturer/SET_SALES_CONTACT_PHONE",
          value
        );
      },
      get() {
        return this.manufacturer.salesContactPhone;
      },
    },
  },
  methods: {
    handlePrev() {
      this.$emit("prev");
    },
    handleNext() {
      this.$emit("next");
    },
  },
};
</script>
